import { useState, useEffect } from 'react';
import axios from 'axios';

export interface Config {
  enableShiftColorCustomization: boolean;
  enableCrewCountCustomization: boolean;
  copyAssignmentsByDate: boolean;
  copyAssignmentsByMonth: boolean;
  copyAssignmentsByWeekdays: boolean;
  copyShiftsByMonth: boolean;
  SESSION_TIMEOUT_MINUTES: string;
  SESSION_WARNING_MINUTES: string;
  allowPastAssignments: boolean;
  ALLOW_MULTIPLE_SCHEDULES?: string;
  ENABLE_SHIFT_SIGNUPS?: string;
  ENABLE_SHIFT_TRADES?: string;
}

const defaultConfig: Config = {
  enableShiftColorCustomization: false,
  enableCrewCountCustomization: false,
  copyAssignmentsByDate: false,
  copyAssignmentsByMonth: false,
  copyAssignmentsByWeekdays: false,
  copyShiftsByMonth: false,
  SESSION_TIMEOUT_MINUTES: '30',
  SESSION_WARNING_MINUTES: '5',
  allowPastAssignments: false
};



export const useConfig = () => {
  const [config, setConfig] = useState<Config>({ 
    enableShiftColorCustomization: false,
    enableCrewCountCustomization: false,
    copyAssignmentsByDate: false,
    copyAssignmentsByMonth: false,
    copyAssignmentsByWeekdays: false,
    copyShiftsByMonth: false,
    SESSION_TIMEOUT_MINUTES: '30',
    SESSION_WARNING_MINUTES: '5',
    allowPastAssignments: false
  });


  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get('/api/config');
        const configData = response.data;
        
        const newConfig: Config = {
          enableShiftColorCustomization: configData.ENABLE_SHIFT_COLOR_CUSTOMIZATION === 'true',
          enableCrewCountCustomization: configData.ENABLE_CREW_COUNT_CUSTOMIZATION === 'true',
          copyAssignmentsByDate: configData.COPY_ASSIGNMENTS_BY_DATE === 'true',
          copyAssignmentsByMonth: configData.COPY_ASSIGNMENTS_BY_MONTH === 'true',
          copyAssignmentsByWeekdays: configData.COPY_ASSIGNMENTS_BY_WEEKDAYS === 'true',
          copyShiftsByMonth: configData.COPY_SHIFTS_BY_MONTH === 'true',
          SESSION_TIMEOUT_MINUTES: configData.SESSION_TIMEOUT_MINUTES || '30',
          SESSION_WARNING_MINUTES: configData.SESSION_WARNING_MINUTES || '5',
          allowPastAssignments: configData.AllowPastAssignments === 'true',
          ALLOW_MULTIPLE_SCHEDULES: configData.ALLOW_MULTIPLE_SCHEDULES || 'false',
          ENABLE_SHIFT_SIGNUPS: configData.ENABLE_SHIFT_SIGNUPS || 'false',
          ENABLE_SHIFT_TRADES: configData.ENABLE_SHIFT_TRADES || 'false'
        };
        setConfig(newConfig);
      } catch (error) {
        setConfig(defaultConfig);
      }
    };

    fetchConfig();
  }, []);

  return { config };
}; 